import { Dices, MessageCircle, Coffee, Wind, Target, Sparkles, Shuffle } from "lucide-react";

// Neutral preset actions (no +/- modifier)
export const PRESET_ACTIONS = [
  { id: "preset-gallop", icon: Dices, label: "Würfle für Galopp", text: "Ich galoppiere mit voller Galopp-Effizienz vorwärts.", withDice: true },
  { id: "preset-jump", icon: Target, label: "Hindernis nehmen", text: "Ich anvisiere das nächste Hindernis und springe.", withDice: true },
  { id: "preset-hammerl", icon: MessageCircle, label: "Sprich mit Hammerl", text: "Ich gehe zu Hammerl und frage nach Galoppstrategie-Beratung.", withDice: false },
  { id: "preset-wiehern", icon: Sparkles, label: "Charismatisches Wiehern", text: "Ich setze mein Charismatisches Wiehern ein, um Aufmerksamkeit zu erzeugen.", withDice: true },
  { id: "preset-rest", icon: Coffee, label: "Rast einlegen", text: "Ich gönne mir eine kurze Pause und tausche mich mit dem Team aus.", withDice: false },
  { id: "preset-improvise", icon: Wind, label: "Improvisieren", text: "Ich improvisiere eine waghalsige Bewegung, die niemand erwartet.", withDice: true },
  { id: "preset-bored", icon: Shuffle, label: "Das langweilt mich. Ich will was anderes machen.", text: "Das langweilt mich. Ich will was anderes machen.", withDice: false },
];

export default function ActionButtons({ options, onPick, disabled, hidden }) {
  if (hidden) return null;
  if (!options || options.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-3" data-testid="action-buttons">
      {options.map((opt) => {
        const Icon = opt.icon || Dices;
        return (
          <button
            key={opt.id}
            type="button"
            disabled={disabled}
            onClick={() => onPick(opt)}
            className="inline-flex items-start gap-1.5 text-xs font-mono uppercase tracking-wider px-2.5 py-1.5 bg-hammerl-card border-2 border-hammerl-ink hover:bg-hammerl-highlight hover:text-hammerl-paper hover:text-hammerl-ink disabled:opacity-40 disabled:cursor-not-allowed transition-colors shadow-brutal-sm hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-none max-w-full text-left leading-snug whitespace-normal break-words"
            data-testid={opt.testId || `action-btn-${opt.id}`}
            title={opt.text}
          >
            <Icon className="w-3.5 h-3.5 shrink-0 mt-0.5" />
            <span className="flex-1 min-w-0 whitespace-normal break-words">{opt.label}</span>
            {opt.withDice && <Dices className="w-3 h-3 text-hammerl-fail shrink-0 mt-0.5" />}
          </button>
        );
      })}
    </div>
  );
}
